import { render } from "./iconCloseLight.vue?vue&type=template&id=09b16a1a"
import script from "./iconCloseLight.vue?vue&type=script&lang=js"
export * from "./iconCloseLight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__